var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","dir":"rtl"}},[_c('header-layout'),_c('main',[_c('page-head'),_c('router-view',{key:_vm.$route.path}),_c('donate-popup')],1),_c('footer-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }